module.exports = __webpack_public_path__ + "img/screening-bg.d983970e.jpeg";